import { render, staticRenderFns } from "./InstruccionEmbarque.vue?vue&type=template&id=5ff1ce2e&scoped=true"
import script from "./InstruccionEmbarque.vue?vue&type=script&lang=js"
export * from "./InstruccionEmbarque.vue?vue&type=script&lang=js"
import style0 from "./InstruccionEmbarque.vue?vue&type=style&index=0&id=5ff1ce2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1ce2e",
  null
  
)

export default component.exports